(function () {
    let isIMO = document.querySelector('.imo2020-header');

    if(isIMO) {
        /*
         * Add resize event to an element
         */
        var attachEvent = document.attachEvent,
            stylesCreated = false;

        if (!attachEvent) {
            var requestFrame = (function(){
                var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
                    function(fn){ return window.setTimeout(fn, 20); };
                return function(fn){ return raf(fn); };
            })();

            var cancelFrame = (function(){
                var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame ||
                    window.clearTimeout;
                return function(id){ return cancel(id); };
            })();

            var resetTriggers = function (element){
                var triggers = element.__resizeTriggers__,
                    expand = triggers.firstElementChild,
                    contract = triggers.lastElementChild,
                    expandChild = expand.firstElementChild;
                contract.scrollLeft = contract.scrollWidth;
                contract.scrollTop = contract.scrollHeight;
                expandChild.style.width = expand.offsetWidth + 1 + 'px';
                expandChild.style.height = expand.offsetHeight + 1 + 'px';
                expand.scrollLeft = expand.scrollWidth;
                expand.scrollTop = expand.scrollHeight;
            };

            var checkTriggers = function (element){
                return element.offsetWidth != element.__resizeLast__.width ||
                    element.offsetHeight != element.__resizeLast__.height;
            }

            var scrollListener = function (e){
                var element = this;
                resetTriggers(this);
                if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
                this.__resizeRAF__ = requestFrame(function(){
                    if (checkTriggers(element)) {
                        element.__resizeLast__.width = element.offsetWidth;
                        element.__resizeLast__.height = element.offsetHeight;
                        element.__resizeListeners__.forEach(function(fn){
                            fn.call(element, e);
                        });
                    }
                });
            };

            /* Detect CSS Animations support to detect element display/re-attach */
            var animation = false,
                animationstring = 'animation',
                keyframeprefix = '',
                animationstartevent = 'animationstart',
                domPrefixes = 'Webkit Moz O ms'.split(' '),
                startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
                pfx  = '';
            {
                var elm = document.createElement('fakeelement');
                if( elm.style.animationName !== undefined ) { animation = true; }

                if( animation === false ) {
                    for( var i = 0; i < domPrefixes.length; i++ ) {
                        if( elm.style[ domPrefixes[i] + 'AnimationName' ] !== undefined ) {
                            pfx = domPrefixes[ i ];
                            animationstring = pfx + 'Animation';
                            keyframeprefix = '-' + pfx.toLowerCase() + '-';
                            animationstartevent = startEvents[ i ];
                            animation = true;
                            break;
                        }
                    }
                }
            }

            var animationName = 'resizeanim';
            var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
            var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
        }

        function createStyles() {
            if (!stylesCreated) {
                // opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
                var css = (animationKeyframes ? animationKeyframes : '') +
                    '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' +
                    '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
                    head = document.head || document.getElementsByTagName('head')[0],
                    style = document.createElement('style');

                style.type = 'text/css';
                if (style.styleSheet) {
                    style.styleSheet.cssText = css;
                } else {
                    style.appendChild(document.createTextNode(css));
                }

                head.appendChild(style);
                stylesCreated = true;
            }
        }

        window.addResizeListener = function(element, fn){
            if (attachEvent) element.attachEvent('onresize', fn);
            else {
                if (!element.__resizeTriggers__) {
                    if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
                    createStyles();
                    element.__resizeLast__ = {};
                    element.__resizeListeners__ = [];
                    (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
                    element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' +
                        '<div class="contract-trigger"></div>';
                    element.appendChild(element.__resizeTriggers__);
                    resetTriggers(element);
                    element.addEventListener('scroll', scrollListener, true);

                    /* Listen for a css animation to detect element display/re-attach */
                    animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function(e) {
                        if(e.animationName == animationName)
                            resetTriggers(element);
                    });
                }
                element.__resizeListeners__.push(fn);
            }
        };

        window.removeResizeListener = function(element, fn){
            if (attachEvent) element.detachEvent('onresize', fn);
            else {
                element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
                if (!element.__resizeListeners__.length) {
                    element.removeEventListener('scroll', scrollListener);
                    element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
                }
            }
        }



        $(window).on('scroll', function () {
            if ($(window).scrollTop() > 100) {
                $('.imo2020-header__menu--floating').removeClass('hidden');
            }
            else {
                $('.imo2020-header__menu--floating').addClass('hidden');
            }
        });
    }

    /*
    * Adds scroll animation to an element
    *
    * params:
    * element
    * direction (1 | -1) - direction of animation (negative for reverse)
    * axis ("x" | "y") animated axis
    * offset (+ | - int) - element/parent element pixels visible in viewport before we start the animation
    */

    function addScrollAnimation(element, direction, axis, offset) {
        let offsetTop;

        if (!element) {
            return;
        } else {
            offsetTop = getElementOffsetTop(element);
        }

        /* Add event listeners */

        window.addEventListener("load", function () {
            setTransform(element, offsetTop, direction, axis, offset);
        }, false);

        window.addEventListener("scroll", function () {
            setTransform(element, offsetTop, direction, axis, offset);
        }, false);
    }


    /*
    * Calculates target element offset based on all its parents' offsets
    */

    function getElementOffsetTop(element) {
        let top = 0;

        do {
            top += element.offsetTop || 0;
            element = element.offsetParent;
        } while (element);

        return top;
    }


    /*
    * Sets element transform
    */

    function setTransform(element, offsetTop, direction, axis, offset) {
        let min = 0;
        let scroll = window.pageYOffset;
        let translate = scroll - offsetTop + window.innerHeight + offset;

        if (translate < min) {
            translate = min;
        } else if (translate > element.parentElement.offsetHeight - element.offsetHeight) {
            translate = element.parentElement.offsetHeight - element.offsetHeight;
        }

        element.style.transform = `translate${axis}(${(translate) * direction}px)`;
    }


    /*
    * Init scroll animation
    */

    let ship = document.querySelector("[js-ship]");

    if (ship) {
        addScrollAnimation(ship, 1, "y", -((window.innerHeight + ship.offsetHeight) / 2));
    }


    /*
    * Init height check for ship background
    */

    let shipBg = document.querySelector("[js-ship-bg]");

    if (ship && shipBg) {
        initHeightWatch(shipBg);
    }

    /*
    * Add event listeners to
    */

    function initHeightWatch(element) {

        if (!element) {
            return;
        }

        window.addEventListener("resize", function () {
            if (window.innerWidth > 900) {
                fixShipBgCutoff(element);
            }
        }, false);

        window.addEventListener("load", function () {
            fixShipBgCutoff(element);
        }, false);
    }


    /*
    * Changes element's height to prevent bg cutoff at the top
    * based on parent element's height
    */

    function fixShipBgCutoff(element) {
        // Actual size of the background used (for the proportions)
        let height = 167;
        let width = 124;
        // Element translation from the top (in pixels)
        let offset = 140;

        let elementWidth = element.offsetWidth;
        let imageHeight = Math.floor(height * elementWidth / width);
        let parentHeight = Math.floor(element.parentElement.offsetHeight - offset);

        let newHeight = parentHeight - (parentHeight % imageHeight);

        if (parentHeight - newHeight >= imageHeight) {
            newHeight += imageHeight;
        }

        element.style.height = `${newHeight}px`;
    }


    /*
    * Survey submit scroll
    */

    let surveyIframe = document.querySelector("#survey iframe");
    let surveyLoadFlag = false;


    /*
    * Add event listeners for survey iframe load
    */

    if (surveyIframe) {
        surveyIframe.addEventListener("load", handleIframeLoad, false);
    }


    /*
    * Scroll to the survey if it was loaded for the second time (TYP was shown)
    */

    function handleIframeLoad() {

        if(surveyLoadFlag) {
            surveyIframe.scrollIntoView();
        }

        surveyLoadFlag = true;
    }


    let steps = document.querySelector(".steps");

    /*
     * Setting up event listeners for collapsible steps
     */

    document.querySelectorAll(".steps__item--collapsible").forEach(element => {
        element.addEventListener("click", function(e){
            if(e.target.classList.contains("single-teaser") ||
                e.target.classList.contains("single-teaser-image") ||
                e.target.classList.contains("video-play") ||
                e.target.classList.contains("image-open")) {
                return;
            }

            e.stopPropagation();
            this.classList.toggle("collapsed");

            // Calling fixShipBgCutoff twice to reduce bg overflow when still transitioning
            fixShipBgCutoff(shipBg);
        });

        addResizeListener(element, function(){
            if(this.classList.contains("collapsed")) {
                window.scrollTo(0, getElementOffsetTop(steps));
            } else {
                window.scrollTo(0, getElementOffsetTop(this));
            }
            fixShipBgCutoff(shipBg);
        });
    });
}());